import { render, staticRenderFns } from "./FormTabs.vue?vue&type=template&id=923b9ccc"
import script from "./FormTabs.vue?vue&type=script&lang=ts"
export * from "./FormTabs.vue?vue&type=script&lang=ts"
import style0 from "./FormTabs.vue?vue&type=style&index=0&id=923b9ccc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports